<template>
  <div style=" height: 250px; width: 110%;">
    <div id="header">设备状态变化曲线</div>
    <!--<div id="leftOne2Select">-->
      <!--<select v-model="select">-->
        <!--<option label="近七天" value="1"></option>-->
        <!--<option label="近一个月" value="2"></option>-->
      <!--</select>-->
    <!--</div>-->
    <div id="subLeftOne2Canvas" style="width: 100%; height: 100%; margin-top: 20px;"></div>
  </div>
</template>

<script>
import echarts from 'echarts'
export default {
  name: 'SubLeftOne2',
  props: ['areaId'],
  data(){
    return {
      GlobalDevScreen:{
        "version": 1,
        "method": "synthScreen.GlobalDevScreen",
        "params": {
          "areaId":"0",
        },
        "token": "",
        "id": 0
      },
      chart:"",
      select: '1',
      option: {
        // title: {
        //   text: '折线图堆叠'
        // },
        tooltip: {
          trigger: 'axis',
          triggerOn:"mousemove",
        },
        legend: {
          y: '0%',
          x: '15%',
          data:['设备供电','设备开机','监测在线','监测分贝'],
          icon: "circle",
          // data:['已巡检','未巡检'],
          textStyle: {
            color: '#fff',
            fontFamily: '黑体',
            fontSize: 12

          },
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          top: '15%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: ['11.1','11.2','11.3','11.4','11.5','11.6','11.7'],
          fontStyle: {
            color: 'white',
          },
          axisLabel: {
            show: true,
            textStyle: {
              fontFamily: '黑体',
              color: 'white',
              fontSize: 12,
            },
          },
          axisLine: {
            lineStyle: {
              color: '#757c96',
              width: 1,
            }
          },
        },
        yAxis: {
          type: 'value',
          minInterval: 1, //设置成1保证坐标轴分割刻度显示成整数。
          axisLabel: {
            show: true,
            textStyle: {
              fontFamily: '黑体',
              color: '#ffffff',
              fontSize: 12,
            },
          },
          splitLine :{    //网格线
            lineStyle:{
              type:'dashed'    //设置网格线类型 dotted：虚线   solid:实线
            },
            show:true //隐藏或显示
          }
        },
        color: ['#2ebb5a','#eeb01a','#188cf8','#a130d5'],
        series: [
          {
            name:'设备供电',
            type:'line',
            stack: '设备供电',
            symbol: 'none',
            data:[220, 182, 191, 234, 290, 330, 310]
          },

          {
            name:'设备开机',
            type:'line',
            stack: '设备开机',
            symbol: 'none',
            data:[150, 232, 201, 154, 190, 330, 410]
          },
          {
            name:'监测在线',
            type:'line',
            stack: '监测在线',
            symbol: 'none',
            data:[120, 132, 101, 134, 90, 230, 210]
          },
          {
            name:'监测分贝',
            type:'line',
            stack: '监测分贝',
            symbol: 'none',
            data:[150, 232, 201, 154, 190, 330, 410]
          },
        ]
      },
      interval:null, // 轮询

    }
  },
  methods:{
    drawChart(charts,id,option){
      console.log('渲染左上');
      charts = echarts.init(document.getElementById(id))
      charts.setOption(option)
    },
    getGlobalDevScreen(){
      this.GlobalDevScreen.token = this.$store.state.token;
      this.GlobalDevScreen.params.areaId = this.areaId;
      console.log('获取设备状态变化曲线');
      console.log(this.GlobalDevScreen);
      this.$axios.post(this.$newMainUrl, this.GlobalDevScreen).then(res=> {
        console.log('获取设备状态变化曲线请求得到响应');
        console.log(res.data);
        if(res.data.hasOwnProperty('result')){
          let dayCEStaNumDate = [];//后台获取到的日期进行排序
          let dayCEStaNumDate1 = [];
          let dayCEStaNumDate2 = {};


          let times = [];


          let dayCEStaNum = []; // 市电供电数
          let dayOnStaNum = []; // 开机数
          let dayOnlineStaNum = []; // 在线数
          let dayAlarmStaNum = []; // 在线数
          // this.alarmNum = []; // 告警数
          dayCEStaNumDate = Object.keys(res.data.result.dayCEStaNum);
          dayCEStaNumDate1 = Object.values(res.data.result.dayCEStaNum);
          for(let i=0;i<dayCEStaNumDate.length;i++){
            dayCEStaNumDate2[dayCEStaNumDate[i]] = dayCEStaNumDate1[i];
          }
          dayCEStaNumDate.sort();
          for(let i=0;i<dayCEStaNumDate.length;i++){
            let t = dayCEStaNumDate[i].slice(5);
            times.push(t);
            dayCEStaNum.push(dayCEStaNumDate2[dayCEStaNumDate[i]]);
          }



          let dayOnStaNumDate = [];//后台获取到的日期进行排序
          let dayOnStaNumDate1 = [];
          let dayOnStaNumDate2 = {};
          dayOnStaNumDate = Object.keys(res.data.result.dayOnStaNum);
          dayOnStaNumDate1 = Object.values(res.data.result.dayOnStaNum);
          for(let i=0;i<dayOnStaNumDate.length;i++){
            dayOnStaNumDate2[dayOnStaNumDate[i]] = dayOnStaNumDate1[i];
          }
          dayOnStaNumDate.sort();
          for(let i=0;i<dayOnStaNumDate.length;i++){
            dayOnStaNum.push(dayOnStaNumDate2[dayOnStaNumDate[i]]);
          }



          let dayOnlineStaNumDate = [];//后台获取到的日期进行排序
          let dayOnlineStaNumDate1 = [];
          let dayOnlineStaNumDate2 = {};
          dayOnlineStaNumDate = Object.keys(res.data.result.dayOnlineStaNum);
          dayOnlineStaNumDate1 = Object.values(res.data.result.dayOnlineStaNum);
          for(let i=0;i<dayOnlineStaNumDate.length;i++){
            dayOnlineStaNumDate2[dayOnlineStaNumDate[i]] = dayOnlineStaNumDate1[i];
          }
          dayOnlineStaNumDate.sort();
          for(let i=0;i<dayOnlineStaNumDate.length;i++){
            dayOnlineStaNum.push(dayOnlineStaNumDate2[dayOnlineStaNumDate[i]]);
          }




          let dayAlarmStaNumDate = [];//后台获取到的日期进行排序
          let dayAlarmStaNumDate1 = [];
          let dayAlarmStaNumDate2 = {};
          dayAlarmStaNumDate = Object.keys(res.data.result.dayAlarmStaNum);
          dayAlarmStaNumDate1 = Object.values(res.data.result.dayAlarmStaNum);
          for(let i=0;i<dayAlarmStaNumDate.length;i++){
            dayAlarmStaNumDate2[dayAlarmStaNumDate[i]] = dayAlarmStaNumDate1[i];
          }
          dayAlarmStaNumDate.sort();
          for(let i=0;i<dayAlarmStaNumDate.length;i++){
            dayAlarmStaNum.push(dayAlarmStaNumDate2[dayAlarmStaNumDate[i]]);
          }




          this.option.series[0].data = dayCEStaNum
          this.option.series[1].data = dayOnStaNum
          this.option.series[2].data = dayOnlineStaNum
          this.option.series[3].data = dayAlarmStaNum;

          this.option.xAxis.data = times;


          this.drawChart(this.chart, 'subLeftOne2Canvas', this.option);
        }else{
          this.$message({
            type:'error',
            message:'获取警报点静态信息失败，' + res.data.error.message
          })
        }
      })
    },

  },
  mounted () {
    this.getGlobalDevScreen();
    this.interval = setInterval(()=>{
      this.getGlobalDevScreen();
    }, 3000)
    // this.drawChart(this.chart, 'subLeftOne2Canvas', this.option);
  },
  destroyed () {
    clearInterval(this.interval);
  }
}
</script>

<style scoped lang="scss">
  #header{
    color: white;
    font-size: 18px;
    font-family: 黑体;
    font-weight: bold;
    margin-left: 10px;
    margin-top: 30px;
  }
  #leftOne2Select{
    select{
      display: block;
      position: relative;
      float: right;
      margin-right: 30px;
      font-size: 10px;
      transform: scale(0.8);
      -webkit-transform: scale(0.8);
      color: white;
      background-color: gray;
      height: 25px;
      width: 80px;
    }
    height: 25px;
  }
  #leftOne2Canvas{
    width: 100%;
    height: 200px;
  }
</style>
